import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import BannerEnum from '../enumerators/banner.enum'

export default class BannerSliderComponent {
    constructor() {
        BannerSliderComponent.init()
    }

    static async init() {
        const options = {
            slidesPerView: 'auto',
            autoplay: {
                delay: 7000,
            },
            speed: 700,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            mousewheel: {
                forceToAxis: true,
            },
            allowTouchMove: false,
            loop: true,
        }

        // insert navigation / pagination
        $(`${BannerEnum.SLIDER}> *`)
            .wrapAll('<div class="swiper-wrapper"></div>')
            .addClass('swiper-slide')

        const swiper = await Swiper.create(BannerEnum.SLIDER, options)

        if ($(BannerEnum.BODY).hasClass('home')) {
            const addActiveClassOnInit = setTimeout(() => {
                $('[data-overtitle-index="0"]').addClass('active')
            }, 500)

            swiper.on('slideChangeTransitionStart', () => {
                $(BannerEnum.HOME_OVERTITLES).removeClass('active')
                clearTimeout(addActiveClassOnInit)
            })

            swiper.on('slideChangeTransitionEnd', function () {
                const currentSlideIndex = this.realIndex
                const currentOvertitle = `[data-overtitle-index="${currentSlideIndex}"]`
                $(currentOvertitle).addClass('active')
            })
        }
    }
}
